import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InfoportalApiComponent } from "./infoportal-api.component";
import { InfoportalApiElevatorOverviewComponent } from "./infoportal-api-elevators/overview/elevators-overview.component";
import { InfoportalApiCustomerOverviewComponent } from "./infoportal-api-customers/overview/customers-overview.component";
import { InfoportalApiElevatorDetailComponent } from "./infoportal-api-elevators/detail/elevators-detail.component";
import { CommonComponentsModule } from "../common-components";
import { InfoportalApiEndCustomerUserOverviewComponent } from "./infoportal-api-customers/endcustomer-users/overview/endcustomer-user-overview.component";
import { InfoportalApiReceiptDocumentsPageComponent } from "./pages/receipt-documents/infoportal-receipt-documents-page.component";
import { InfoportalApiContractDocumentsPageComponent } from "./pages/contract-documents/infoportal-contract-documents-page.component";
import { InfoportalApiElevatorDisplayNotesComponent } from "./infoportal-api-elevators/display-notes/elevators-displayNotes.component";
import { InfoportalApiElevatorDisplayWartungshistoryComponent } from "./infoportal-api-elevators/display-wartungshistory/elevators-displayWartungshistory.component";
import { InfoportalApiGuard } from "../guards";
import { VertragApiGuard } from "../guards/vertrag-api.guard";

const infoportalRoutes: Routes = [
  {
    path: "",
    component: InfoportalApiComponent,
    children: [
      { path: "", redirectTo: "anlagen", pathMatch: "full" },
      {
        path: "customers",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiCustomerOverviewComponent,
      },
      {
        path: "customers/:id/endcustomers",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiEndCustomerUserOverviewComponent,
      },
      {
        path: "kunden",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiCustomerOverviewComponent,
      },
      {
        path: "kunden/:id/endkunden",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiEndCustomerUserOverviewComponent,
      },
      {
        path: "anlagen",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiElevatorOverviewComponent,
      },
      {
        path: "anlagen/:id",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiElevatorDetailComponent,
      },
      {
        path: "contracts/documents",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiContractDocumentsPageComponent,
      },
      {
        path: "receipts/documents",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiReceiptDocumentsPageComponent,
      },
      {
        path: "anlagen/:id/notes",
        canActivate: [InfoportalApiGuard],
        component: InfoportalApiElevatorDisplayNotesComponent,
      },
      {
        path: "anlagen/:id/history",
        canActivate: [InfoportalApiGuard, VertragApiGuard],
        component: InfoportalApiElevatorDisplayWartungshistoryComponent,
      },
    ],
  },
];

@NgModule({
  imports: [CommonComponentsModule, RouterModule.forChild(infoportalRoutes)],
  declarations: [],
  exports: [RouterModule],
})
export class InfoportalApiRoutingModule {}
